<script setup>
import { onClickOutside } from '@vueuse/core';
import { Close } from './Icons';
import { ref }   from 'vue';

const isOpen = defineModel();

const targetEl = ref(null);

const emit = defineEmits();

onClickOutside(targetEl, () => isOpen.value = false)
</script>

<template>
	<div class="form-close">
		<div class="form-close-wr" ref="targetEl">
			<button
				class="close-popup"
				@click="isOpen = false"
			>
				<Close />
			</button>
			<h3 class="form-close__header">Вы уверены, что хотите закрыть?</h3>
			<span class="form-close__description">При закрытии формы все введенные данные не сохранятся</span>
			<div class="form-close__btns">
				<button class="long-btn" @click="$emit('closePopup')">Закрыть</button>
				<button class="long-btn" @click="isOpen = false">Продолжить запись</button>
			</div>
		</div>
	</div>
</template>

<style lang='scss'>
.form-close {
	position: absolute;
	display: flex;
	align-items: flex-end;
	z-index: 100;
	inset: 0;
	background-color: #0000008A;

	@include mq($tablet) {
		align-items: center;
		justify-content: center;
	}
}

.form-close-wr {
	width: 100%;
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: unset;
	padding: 20px 16px;
	border-radius: 20px 20px 0 0;
	background-color: #FFF;

	.close-popup {
		position: absolute;
		top: 32px;
		right: 32px;
		display: none;
	}

	@include mq($tablet) {
		max-width: 648px;
		max-height: unset;
		padding: 32px;
		border-radius: 20px;
		max-height: 285px;

		.close-popup { display: block }
	}

	@include mq($large) {
		max-width: 720px;
		padding: 40px;

		.close-popup {
			top: 40px;
			right: 40px;
		}
	}
}

.form-close__header {
	font-size: 18px;
	font-weight: 600;
	line-height: 36px !important;
	text-align: center;

	@include mq($tablet) { max-width: unset }

	@include mq($large) { font-size: 24px }
}

.form-close__description {
	max-width: 310px;
	margin-top: 4px;
	display: block;
	font-size: 14px;
	line-height: 20px !important;
	text-align: center;

	@include mq($tablet) { max-width: unset }

	@include mq($large) { font-size: 16px; }
}

.form-close__btns {
	width: 100%;
	margin-top: 24px;
	display: flex;
	flex-direction: column;
	gap: 20px;
	padding-bottom: 70px;

	button { border: 2px solid $yellow }

	button:nth-child(1) {
		color: $yellow;
		background-color: #FFF;
		border: 2px solid $yellow;
	}

	@include mq(560px) { padding-bottom: 0 }

	@include mq($tablet) { flex-direction: row }

	@include mq($large) {
		margin-top: 32px;
		gap: 24px;
	}
}
</style>